import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import { Google, Pixall } from 'reaxl-analytics-handlers';

import { addListingTriggerData, getInventoryOwnerById, isPremiumSpotlight } from '@/analytics/utilities';
/**
 * @summary Sends Pixall/Google Click event
 * @cmp dif_txt_pa_lnk
 * @data inventoryId, filterDuck
 * @events event1
 */
export function inventoryDealerDiffClick({ event, data = {}, dataLayer, state }, option) {

    const { clickType, ctaType: customCtaType, cmp: customCmp, inventoryId, paginatedListingIndex, eventResult, eventData = '', eventElement = 'dealer-diff', par } = data;
    const label = event?.target?.innerText || event?.target?.textContent;

    let cmp = customCmp;
    let ctaType = customCtaType;

    if (label?.includes('Get Your Down Payment')) {
        ctaType = 'modalCta';
    }

    // cta = dealer diff listing CTA, link = dealer diff listing link, modalCta = dealer diff modal CTA
    if (ctaType === 'cta') {
        cmp = 'pr_adv_lgo';
    } else if (ctaType === 'link') {
        cmp = 'dif_txt_lnk';
    } else if (ctaType === 'modalCta') {
        cmp = 'dif_txt_pa_lnk';
    }

    const listingType = isPremiumSpotlight(par) ? 'highlight' : undefined;

    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const inventory = getInventoryOwnerById(state, inventoryId);

    const additionalEventData = {
        vehicle: {
            clickType,
            listingPosition: paginatedListingIndex,
        },
        ...eventData,
    };

    const eventResultFormatted = eventResult?.ctaLabel && `${eventResult.prefix}${_kebabCase(eventResult.ctaLabel)}`;

    Google.sendClickEvent({
        eventElement,
        eventResult: eventResultFormatted,
        eventData: additionalEventData,
    }, option);

    Pixall.sendClickEvent({
        label: ctaType === 'modalCta' ? `Click to Dealer Site - ${cmp}` : `Click to Dealer Site - ${cmp} - ${pageId}`,
        eventSource: 'dealership',
        feature: 'Drive the 5',
        inventory,
        listingType,
        pixallData: {
            clickTypeToListingType: pageId === 'fyc_vdp',
        },
        cdl: addListingTriggerData(par, {
            eventProperties: {
                event: {
                    valueEventCode: '0AAD',
                },
            },
        }),
        par,
    }, dataLayer, option);

    // return data for custom event
    return { cmp };
}
